import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// MARK://dhk8/ui-restaurant/NumPad
// Touch numeric keypad — PIN entry, covers, quick quantities, cash amounts.
// Controlled: parent owns the string value. `mode` tweaks the bottom-row keys.
// ADR-0032 §"sc-restaurant — qué portar": <NumPad> reimplemented on the new stack.
import { Delete, Check } from 'lucide-react';
export function NumPad({ value, onChange, maxLength = 12, mode = 'integer', onConfirm, disabled = false, ariaLabel = 'Teclado numérico', }) {
    function pushDigit(d) {
        if (disabled)
            return;
        if (value.length >= maxLength)
            return;
        if (d === '.') {
            if (mode !== 'decimal' || value.includes('.'))
                return;
            onChange(value === '' ? '0.' : value + '.');
            return;
        }
        onChange(value + d);
    }
    function backspace() {
        if (disabled)
            return;
        onChange(value.slice(0, -1));
    }
    function tertiary() {
        if (disabled)
            return;
        if (onConfirm)
            onConfirm();
        else
            onChange('');
    }
    const tertiaryKey = mode === 'decimal' ? { label: '.', action: () => pushDigit('.'), aria: 'Punto decimal' }
        : onConfirm ? { label: _jsx(Check, { size: 20 }), action: tertiary, aria: 'Confirmar' }
            : { label: _jsx(Check, { size: 20 }), action: tertiary, aria: 'Limpiar' };
    return (_jsxs("div", { className: "dhk8-numpad", role: "group", "aria-label": ariaLabel, "aria-disabled": disabled, children: [['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (_jsx("button", { type: "button", className: "dhk8-numpad__key", onClick: () => pushDigit(d), disabled: disabled, "aria-label": `Dígito ${d}`, children: d }, d))), _jsx("button", { type: "button", className: "dhk8-numpad__key dhk8-numpad__key--ghost", onClick: backspace, disabled: disabled, "aria-label": "Borrar", children: _jsx(Delete, { size: 20 }) }), _jsx("button", { type: "button", className: "dhk8-numpad__key", onClick: () => pushDigit('0'), disabled: disabled, "aria-label": "D\u00EDgito 0", children: "0" }), _jsx("button", { type: "button", className: "dhk8-numpad__key dhk8-numpad__key--ghost", onClick: tertiaryKey.action, disabled: disabled, "aria-label": tertiaryKey.aria, children: tertiaryKey.label }), _jsx("style", { children: styles })] }));
}
const styles = `
  /* HIG-green keypad: rounded soft keys, hairline outline, full-fill press state.
     Reads the host app's --pos-* tokens; falls back to legacy @dockethub/ui aliases,
     then to literal Restaurant-Dark values so it never goes brutalist. */
  .dhk8-numpad {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: var(--pos-space-2, var(--space-2, 8px));
  }
  .dhk8-numpad__key {
    min-height: var(--pos-touch-target-lg, 56px);
    height: 64px;
    border: 1px solid var(--pos-separator, var(--separator-opaque, rgba(255,255,255,.14)));
    background: var(--pos-surface, var(--bg-surface, var(--surface, #161C18)));
    color: var(--pos-fg, var(--text-primary, var(--fg, #E8EFE9)));
    font-family: var(--font-display, inherit);
    font-size: var(--pos-text-xl, var(--text-xl, 1.25rem));
    font-weight: var(--pos-weight-medium, 500);
    font-variant-numeric: tabular-nums;
    cursor: pointer;
    transition: background var(--pos-duration-fast, 120ms) var(--pos-ease-out, ease),
                box-shadow var(--pos-duration-fast, 120ms) var(--pos-ease-out, ease),
                transform var(--pos-duration-fast, 120ms) var(--pos-ease-out, ease);
    user-select: none;
    border-radius: var(--pos-radius-lg, 12px);
  }
  .dhk8-numpad__key:hover:not(:disabled) {
    background: var(--pos-elevated, var(--surface-elevated, #1E2520));
  }
  .dhk8-numpad__key:active:not(:disabled) {
    background: var(--pos-tint, var(--accent, #1F8B3A));
    border-color: var(--pos-tint, var(--accent, #1F8B3A));
    color: #fff;
    transform: scale(0.97);
  }
  .dhk8-numpad__key:disabled { opacity: 0.35; cursor: not-allowed; }
  .dhk8-numpad__key--ghost {
    color: var(--pos-fg-tertiary, var(--text-tertiary, var(--fg-muted, #7E8C82)));
    background: transparent;
    border-color: transparent;
    display: inline-flex; align-items: center; justify-content: center;
  }
  .dhk8-numpad__key--ghost:hover:not(:disabled) {
    background: var(--pos-tint-soft, color-mix(in oklch, #1F8B3A 12%, transparent));
    color: var(--pos-fg, var(--text-primary, #E8EFE9));
  }
  .dhk8-numpad__key--ghost:active:not(:disabled) {
    background: var(--pos-tint-soft, color-mix(in oklch, #1F8B3A 18%, transparent));
    color: var(--pos-tint, var(--accent, #1F8B3A));
  }
`;
//# sourceMappingURL=NumPad.js.map